module.exports = __webpack_public_path__ + "media/custom/images/img26-7064cf1b53a9e3ecfef5eaaf62170fad.png";